import { TEMPERATURE_RULES } from '../../constants/rules';

export class TemperatureGenerator {
    constructor(templates) {
        this.templates = templates;
    }

    analyzeTemperatureDistribution(globalTemp, _partitionsData) {
        let conclusion = "";

        // 基本色温描述
        if (!globalTemp?.colorTemperature?.rules) {
            return this.templates.temperature.analysis.noRules;
        }

        const rules = globalTemp.colorTemperature.rules;

        // 添加基本色温描述
        if (rules.tone?.length > 0) {
            const toneTemplate = this.templates?.temperature?.rules?.tone[rules.tone[0]];
            if (toneTemplate) {
                conclusion = this.templates.temperature.analysis.prefix + toneTemplate;
            }
        }

        // 添加强度描述
        if (rules.intensity?.length > 0) {
            const intensityTemplate = this.templates?.temperature?.rules?.intensity[rules.intensity[0]];
            if (intensityTemplate) {
                conclusion += conclusion
                    ? this.templates.temperature.analysis.conclusion.period + intensityTemplate
                    : intensityTemplate;
            }
        }

        return conclusion;
    }

    generateConclusion(globalData, partitionsData) {
        let conclusions = [];

        // 基本色温分析
        const temperatureDistribution = this.analyzeTemperatureDistribution(globalData, partitionsData);
        if (temperatureDistribution) {
            conclusions.push(temperatureDistribution);
        }

        // 分析整体一致性
        if (TEMPERATURE_RULES.OVERALL_TEMP_CONSISTENCY.condition(globalData, partitionsData)) {
            const template = this.templates?.temperature?.overallAnalysis?.consistency?.OVERALL_TEMP_CONSISTENCY;
            if (template) {
                conclusions.push(template);
            }
        }

        // 分析全局-分区差异性
        const variations = TEMPERATURE_RULES.OVERALL_TEMP_VARIATIONS.condition(globalData, partitionsData);
        if (variations) {
            let variationDesc = this.templates?.temperature?.overallAnalysis?.variations?.OVERALL_TEMP_VARIATIONS;

            // 添加具体分区差异描述
            const partitionDescs = variations.map(partition => {
                const intensityText = partition.intensity === 'STRONG'
                    ? this.templates.temperature.analysis.conclusion.partitionTemp.strong
                    : partition.intensity === 'MODERATE'
                        ? this.templates.temperature.analysis.conclusion.partitionTemp.moderate
                        : '';

                const toneText = partition.tone.includes('YELLOW')
                    ? this.templates.temperature.analysis.conclusion.partitionTemp.warm
                    : partition.tone.includes('BLUE')
                        ? this.templates.temperature.analysis.conclusion.partitionTemp.cool
                        : partition.tone === 'NEUTRAL'
                            ? this.templates.temperature.analysis.conclusion.partitionTemp.neutral
                            : '';

                // 使用模板中的分区名称映射
                const partitionName = this.templates.mappings.partitions[partition.name];
                return `${partitionName}${intensityText}${toneText}`;
            });

            if (partitionDescs.length > 0) {
                variationDesc += this.templates.temperature.analysis.conclusion.separator +
                    this.templates.temperature.analysis.conclusion.partitionVariation
                        .replace("${descriptions}", partitionDescs.join(this.templates.temperature.analysis.conclusion.separator));
            }

            if (variationDesc) {
                conclusions.push(variationDesc);
            }
        }

        // 明暗分区对比
        if (TEMPERATURE_RULES.SHADOW_HIGHLIGHT_TEMP_CONTRAST.condition(globalData, partitionsData)) {
            const template = this.templates?.temperature?.overallAnalysis?.contrast?.SHADOW_HIGHLIGHT_TEMP_CONTRAST;
            if (template) {
                conclusions.push(template);
            }
        }

        let finalConclusion = conclusions.join(this.templates.temperature.analysis.conclusion.period);
        // 在最后添加period
        finalConclusion += this.templates.temperature.analysis.conclusion.period;
        return finalConclusion || this.templates.temperature.analysis.noData;
    }
}